import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthService} from "./auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> | any {
    return next.handle(request).pipe(
      catchError((error) => {
        if (request.url === 'portalApiUrl/omnis/auth/refresh-token' && error.status === 401) {
          this.authService.logout('login');
          return [];
        } else if (
          error instanceof HttpErrorResponse &&
          request.url.indexOf('/token') === -1 &&
          error.status === 401
        ) {
          let currentUser = this.authService.currentUserValue;
          return this.handle401Error(currentUser);
        }
        this.handleError(error);
        return throwError(error);
      })
    );
  }

  private handle401Error(currentUser: any) {
    if (currentUser) {
      const token = currentUser.refresh_token;
      if (token) {
        this.authService.refreshToken(token).subscribe();
      } else {
        this.authService.logout('login');
      }
    }

    return [];
  }

  private handleError(error: HttpErrorResponse) {
    switch (error.status) {
      case 0:
        console.error('An error occurred:', error.error);
        break;
      case 401:
        console.error('Unautorized error:', error.error);
        break;
      default:
        console.error(`Error code ${error.status}, error: `, error.error);
    }
    return throwError('Something bad happened; please try again later.');
  }
}
